import { render, staticRenderFns } from "./DataTableNoData.vue?vue&type=template&id=0a125ccf&scoped=true"
import script from "./DataTableNoData.vue?vue&type=script&lang=js"
export * from "./DataTableNoData.vue?vue&type=script&lang=js"
import style0 from "./DataTableNoData.vue?vue&type=style&index=0&id=0a125ccf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a125ccf",
  null
  
)

export default component.exports